<div class="ml-auto col-auto">
  <a nbButton type="button" size="tiny" status="basic" class="btn ml-3" [routerLink]="['/pages/template/'+template?.id+'/edit']">
    <nb-icon icon="edit-outline" pack="eva"></nb-icon> Edit
  </a>
  <a nbButton size="tiny" status="basic" class="btn ml-3" [routerLink]="['/pages/template/'+template?.id+'/medialib']">
    <nb-icon icon="film-outline" pack="eva"></nb-icon> Media lib
  </a>
  <a nbButton size="tiny" status="basic" class="btn ml-3" [routerLink]="['/pages/template/'+template?.id+'/edit-roles']" *ngIf="template?.hasRoles">
    <nb-icon icon="edit-2-outline" pack="eva"></nb-icon> Edit Roles
  </a>
  <a nbButton size="tiny" status="basic" class="btn ml-3" [routerLink]="['/pages/template/'+template?.id+'/edit-characters']" *ngIf="template?.hasCharacters">
    <nb-icon icon="edit-2-outline" pack="eva"></nb-icon> Edit Characters
  </a>
  <a nbButton size="tiny" status="basic" class="btn ml-3" *ngIf="template?.hasObjects" [routerLink]="['/pages/template/'+template?.id+'/edit-objects']">
    <nb-icon icon="edit-2-outline" pack="eva"></nb-icon> Edit Objects
  </a>
  <a nbButton size="tiny" status="basic" class="btn ml-3" *ngIf="template?.hasResources" [routerLink]="['/pages/template/'+template?.id+'/edit-resources']">
    <nb-icon icon="edit-2-outline" pack="eva"></nb-icon> Edit Resources
  </a>
  <a nbButton size="tiny" status="basic" class="btn ml-3" *ngIf="template?.hasBuildings" [routerLink]="['/pages/template/'+template?.id+'/edit-buildings']">
    <nb-icon icon="edit-2-outline" pack="eva"></nb-icon> Edit Buildings
  </a>
  <a nbButton type="button" size="tiny" status="basic" class="btn ml-3" [routerLink]="['/pages/template/'+template?.id+'/edit-missions']">
    <nb-icon icon="list-outline" pack="eva"></nb-icon> Missions
  </a>
  <a nbButton type="button" size="tiny" status="basic" class="btn ml-3" [routerLink]="['/pages/template/'+template?.id+'/diagram']">
    <nb-icon icon="share-outline" pack="eva"></nb-icon> Diagram
  </a>
  <a nbButton type="button" size="tiny" status="basic" class="btn ml-3" [routerLink]="['/pages/template/'+template?.id+'/overview']">
    <nb-icon icon="eye-outline" pack="eva"></nb-icon> Preview
  </a>
</div>